import { render, staticRenderFns } from "./step2Dialogs.vue?vue&type=template&id=6e16d854&"
import script from "./step2Dialogs.vue?vue&type=script&lang=js&"
export * from "./step2Dialogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports